(ns app.front.view.public-notice.contacts
  (:require ["@carbon/icons-react/es/send/32" :default Send32]
            [app.front.entities :as entities]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.util :as futil :refer [for-all]]
            [app.front.validate :as validate :refer [field-invalid-text field-invalid?]]
            [app.front.view.workspace.subs :as ws-subs]
            [clojure.string :as str]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]))

(def error-messages {:public-notice-contact/email      [[validate/Email :validate/wrong-email-address]]
                     :public-notice-contact/first-name [[validate/NonBlankString :validate/blank-first-name]]
                     :public-notice-contact/last-name  [[validate/NonBlankString :validate/blank-last-name]]})


(rf/reg-sub ::contacts-visible?
  (fn [[_ target-id] _]
    [(rf/subscribe [:app.front.process/signal-permitted? target-id [:process.signal/add-public-notice-contact]])
     (rf/subscribe [::ws-subs/public-notice-contacts])])
  (fn [[add-permitted? contacts] _]
    (or add-permitted?
        (-> contacts seq boolean))))



(rf/reg-sub ::adding?
  #(get % ::adding?))


(rf/reg-sub ::show-errors?
  #(get % ::show-errors?))


(rf/reg-sub ::new-contact
  #(get % ::new-contact))


(rf/reg-sub ::edited-contact
  #(get % ::edited-contact))


(rf/reg-sub ::selected-contacts
  (fn [db _]
    (-> db ::selected-contacts)))


(rf/reg-sub ::council-decisions
  :<- [::entities/entities {:entity/type :entity.type/council-decision}]
  (fn [decisions [_ id]]
    (sort-by :council-decision/decision-date
             (filter #(= (:db/id (:entity/parent %)) id) decisions))))


(rf/reg-sub ::selected-decision
  (fn [db _]
    (-> db :contacts/selected-decision)))


(rf/reg-sub ::contact-valid?
  (fn [[_ contact-sub] _]
    (rf/subscribe [contact-sub]))
  (fn [contact _]
    (empty? (validate/validate-form-strict contact error-messages))))


(rf/reg-sub ::sorted-contacts
  :<- [::ws-subs/public-notice-contacts]
  (fn [contacts _]
    ; Old contacts may not have names, so take that into account and order by email.
    (sort-by (juxt (comp (fnil str/lower-case "") :public-notice-contact/first-name)
                   (comp (fnil str/lower-case "") :public-notice-contact/last-name)
                   :public-notice-contact/email)
             contacts)))

(rf/reg-sub ::all-contacts-selected?
  :<- [::sorted-contacts]
  :<- [::selected-contacts]
  (fn [[all-contacts selected-contacts] _]
    (= (count all-contacts) (count selected-contacts))))


(rf/reg-event-db ::set-edited-contact
  (fn [db [_ contact]]
    (assoc db ::edited-contact contact)))


(rf/reg-event-db ::toggle-adding-contact
  (fn [db [_]]
    (-> db
        (dissoc ::show-errors?)
        (update ::adding? not))))


(rf/reg-event-db ::set-new-contact-value
  (fn [db [_ key value]]
    (assoc-in db [::new-contact key] value)))


(rf/reg-event-db ::set-edited-contact-value
  (fn [db [_ key value]]
    (assoc-in db [::edited-contact key] value)))


(rf/reg-event-db ::toggle-contact-inform-select
  (fn [db [_ selecting? id]]
    (if selecting?
      (update db ::selected-contacts (fnil conj #{}) id)
      (update db ::selected-contacts (fnil disj #{}) id))))


(rf/reg-event-db ::select-all-contacts
  (fn [db [_ contacts]]
    (let [selected (into #{} (concat (for [contact contacts] (:db/id contact))))]
      (assoc db ::selected-contacts selected))))


(rf/reg-event-db ::unselect-all-contacts
  (fn [db []]
    (assoc db ::selected-contacts #{})))


(rf/reg-event-db ::select-decision
  (fn [db [_ decision]]
    (assoc db :contacts/selected-decision decision)))


(rf/reg-event-fx ::inform-contact
  (fn [{:keys [db]} [_ id email tr]]
    {:comm/command {:command    :public-notice/inform-contact
                    :data       {:contact-id  id
                                 :decision-id (-> db :contacts/selected-decision)}
                    :on-success [::contact-inform.success]
                    :notify     {:success (tr [:public-notice-contact/email-sent] [email])}}}))


(rf/reg-event-fx ::contact-inform.success
  (fn [{:keys [db]} [_ status response]]
    {:dispatch [::entities/apply-changes status response]
     :db       (dissoc db ::show-errors?)}))


(rf/reg-event-fx ::add-contact
  (fn [{:keys [db]} [_ app]]
    (let [new-contact (::new-contact db)]
      (merge {:db (assoc db ::show-errors? true)}
             (when (empty? (validate/validate-form new-contact error-messages))
               {:dispatch [:app.front.process/signal
                           (:db/id app)
                           [:process.signal/add-public-notice-contact new-contact]
                           {:on-success [::contact-add.success]
                            :notify     {:success :public-notice-contact/edited}}]})))))


(rf/reg-event-fx ::save-contact
  (fn [{:keys [db]} [_ app]]
    (let [contact (::edited-contact db)]
      (merge {:db (assoc db ::show-errors? true)}
             (when (empty? (validate/validate-form contact error-messages))
               {:dispatch [:app.front.process/signal
                           (:db/id app)
                           [:process.signal/edit-public-notice-contact (merge {:contact-id (:db/id contact)}
                                                                              (select-keys contact [:public-notice-contact/email
                                                                                                    :public-notice-contact/first-name
                                                                                                    :public-notice-contact/last-name]))]
                           {:on-success [::contact-save.success]
                            :notify     {:success :public-notice-contact/edited}}]})))))


(rf/reg-event-fx ::contact-add.success
  (fn [{:keys [db]} [_ status response]]
    {:dispatch [::entities/apply-changes status response]
     :db       (-> db
                   (dissoc ::show-errors?)
                   (dissoc ::new-contact)
                   (dissoc ::adding?))}))


(rf/reg-event-fx ::contact-save.success
  (fn [{:keys [db]} [_ status response]]
    {:dispatch [::entities/apply-changes status response]
     :db       (-> db
                   (dissoc ::edited-contact)
                   (dissoc ::show-errors?))}))


(rf/reg-event-fx ::delete-contact
  (fn [_ [_ tr id email fsm-target]]
    {:dispatch [:app.front.process/signal
                fsm-target
                [:process.signal/delete-public-notice-contact {:contact-id id}]
                {:on-success [::close-remove-modal]
                 :notify     {:success (tr [:public-notice-contact/contact-removed] [email])}}]}))


(rf/reg-event-fx ::validate-contact
  (fn [{:keys [db]} [_ contact-key]]
    (let [contact (contact-key db)]
      (validate/validate-form contact error-messages)
      {:db (assoc db ::show-errors? true)})))


(rf/reg-event-db ::show-remove-modal
  (fn [db [_ contact]]
    (assoc db ::contact-to-remove contact)))


(rf/reg-event-db ::close-remove-modal
  (fn [db _]
    (dissoc db ::contact-to-remove)))


(rf/reg-sub ::contact-to-remove
  :-> ::contact-to-remove)


(rf/reg-sub ::show-remove-modal?
  :<- [::contact-to-remove]
  boolean)


(defn add-contact-block [{:keys [fsm-target tr adding?]}]
  (let [validator    #(validate/validate-field % (<sub [::new-contact]) error-messages)
        show-errors? (<sub [::show-errors?])
        valid?       (and (<sub [::new-contact]) (<sub [::contact-valid? ::new-contact]))]
    (when adding?
      [:div.bg-light-gray.border-dashed.border-2.border-ui-gray.mb-2
       [:div
        {:class "p-2 flex bg-white"}
        [:div.flex-1.pr-4
         (cc/text-input {:id           "input-email-new-contact"
                         :label-text   (tr [:public-notice-contact/email])
                         :light        true
                         :placeholder  (tr [:placeholder/email])
                         :invalid      (field-invalid? show-errors? validator :public-notice-contact/email)
                         :invalid-text (field-invalid-text show-errors? validator :public-notice-contact/email tr)
                         :on-change    #(rf/dispatch-sync [::set-new-contact-value :public-notice-contact/email (futil/tval %)])})]
        [:div.flex-1.pr-4
         (cc/text-input {:id           "input-first-name-new-contact"
                         :label-text   (tr [:user/first-name])
                         :light        true
                         :invalid      (field-invalid? show-errors? validator :public-notice-contact/first-name)
                         :invalid-text (field-invalid-text show-errors? validator :public-notice-contact/first-name tr)
                         :on-change    #(rf/dispatch-sync [::set-new-contact-value :public-notice-contact/first-name (futil/tval %)])})]
        [:div.flex-1.pr-4
         (cc/text-input {:id           "input-last-name-new-contact"
                         :label-text   (tr [:user/last-name])
                         :light        true
                         :invalid      (field-invalid? show-errors? validator :public-notice-contact/last-name)
                         :invalid-text (field-invalid-text show-errors? validator :public-notice-contact/last-name tr)
                         :on-change    #(rf/dispatch-sync [::set-new-contact-value :public-notice-contact/last-name (futil/tval %)])})]
        [:div.flex-1.text-right.pt-4
         (cc/button {:kind             :ghost
                     :icon-position    :right
                     :size             :small
                     :icon             i/remove
                     :icon-description (tr [:cancel])
                     :on-click         #(>evt [::toggle-adding-contact])}
                    (tr [:cancel]))
         (cc/button {:kind             :primary
                     :icon-position    :right
                     :size             :small
                     :icon             i/plus
                     :icon-description (tr [:public-notice-contact/add])
                     :on-click         #(>evt [::add-contact fsm-target])
                     :disabled         (not valid?)}
                    (tr [:public-notice-contact/add]))]]])))


(defn export-button [tr]
  (let [workspace (<sub [::ws-subs/workspace])
        contacts  (<sub [::sorted-contacts])]
    (cc/button
      {:kind          :ghost
       :icon-position :right
       :icon          i/download
       :class-name    "my-2 ml-2"
       :disabled      (empty? contacts)
       :href          (str "/api/command/property/download-contact-export?workspace-id=" (:workspace/id workspace))}
      (tr [:public-notice/download-contact-list]))))


(defn contact-table [tr]
  (let [format-date       (<sub [::date-util/date-fn])
        fsm-target        (<sub [::ws-subs/application])
        contacts          (<sub [::sorted-contacts])
        edited-contact    (<sub [::edited-contact])
        selected-contacts (<sub [::selected-contacts])
        council-decisions (<sub [::council-decisions (:db/id fsm-target)])
        validator         #(validate/validate-field % edited-contact error-messages)
        valid?            (<sub [::contact-valid? ::edited-contact])
        show-errors?      (<sub [::show-errors?])
        contact-to-remove (<sub [::contact-to-remove])]

    [:<>
     [ui/confirm-modal
      {:open?        (<sub [::show-remove-modal?])
       :tr           tr
       :id           "remove-contact-modal"
       :modal-title  (tr [:public-notice-contact/remove])
       :on-close     #(>evt [::close-remove-modal])
       :on-yes-click #(>evt [::delete-contact tr (:db/id contact-to-remove) (:public-notice-contact/email contact-to-remove) fsm-target])}
      (tr [:public-notice-contact/remove-confirm])]
     [ui-table/modern-responsive-table
      {:tr                tr
       :class             "mt-4"
       :empty-placeholder :public-notice-contact/no-contacts
       :items             (map (fn [{:db/keys [id] :as contact}]
                                 (let [edit? (-> edited-contact :db/id (= id))]
                                   (util/mmap {:edit?    edit?
                                               :checked? (true? (some (partial = id) selected-contacts))}
                                              contact)))
                               contacts)
       :cols              [[nil
                            (fn [{:keys [contact edit? checked?]}]
                              (when (not edit?)
                                (cc/checkbox {:id         (str (:db/id contact) "-inform-checkbox")
                                              :label-text (str (tr [:select/select]) " "
                                                               (:public-notice-contact/first-name contact) " "
                                                               (:public-notice-contact/last-name contact))
                                              :hide-label true
                                              :checked    checked?
                                              :on-change  #(>evt [::toggle-contact-inform-select % (:db/id contact)])})))
                            {:flex 1}]
                           [:user/first-name
                            (fn [{:keys [contact edit?]}]
                              (if edit?
                                (cc/text-input {:id            (str "input-first-name-contact-" (:db/id contact))
                                                :label-text    (tr [:user/first-name])
                                                :light         true
                                                :default-value (:public-notice-contact/first-name edited-contact)
                                                :invalid       (field-invalid? show-errors? validator :public-notice-contact/first-name)
                                                :invalid-text  (field-invalid-text show-errors? validator :public-notice-contact/first-name tr)
                                                :on-blur       #(>evt [::validate-contact ::edited-contact])
                                                :on-change     #(>evt [::set-edited-contact-value :public-notice-contact/first-name (futil/tval %)])})
                                (:public-notice-contact/first-name contact)))
                            {:flex 8}]
                           [:user/last-name
                            (fn [{:keys [contact edit?]}]
                              (if edit?
                                (cc/text-input {:id            (str "input-last-name-contact-" (:db/id contact))
                                                :label-text    (tr [:user/last-name])
                                                :light         true
                                                :default-value (:public-notice-contact/last-name edited-contact)
                                                :invalid       (field-invalid? show-errors? validator :public-notice-contact/last-name)
                                                :invalid-text  (field-invalid-text show-errors? validator :public-notice-contact/last-name tr)
                                                :on-blur       #(>evt [::validate-contact ::edited-contact])
                                                :on-change     #(>evt [::set-edited-contact-value :public-notice-contact/last-name (futil/tval %)])})
                                (:public-notice-contact/last-name contact)))
                            {:flex 8}]
                           [:user/email
                            (fn [{:keys [contact edit?]}]
                              (if edit?
                                (cc/text-input {:id            (str "input-email-contact-" (:db/id contact))
                                                :label-text    (tr [:public-notice-contact/email])
                                                :placeholder   (tr [:placeholder/email])
                                                :light         true
                                                :default-value (:public-notice-contact/email edited-contact)
                                                :invalid       (field-invalid? show-errors? validator :public-notice-contact/email)
                                                :invalid-text  (field-invalid-text show-errors? validator :public-notice-contact/email tr)
                                                :on-blur       #(>evt [::validate-contact ::edited-contact])
                                                :on-change     #(>evt [::set-edited-contact-value :public-notice-contact/email (futil/tval %)])})
                                (:public-notice-contact/email contact)))
                            {:flex 8}]
                           [:public-notice-contact/created
                            (fn [{{:entity/keys [created creator] :as contact} :contact}]
                              (str ((<sub [::date-util/date-time-fn]) created)
                                   (if (= (-> contact :public-notice-contact/type)
                                          :public-notice-contact.type/self-registered)
                                     (str ", " (tr [:public-notice-contact/subscribed]))
                                     (str (tr [:public-notice-contact/created-by])
                                          (:user/first-name creator) " "
                                          (:user/last-name creator)))))
                            {:flex 6}]
                           [:public-notice-contact/informed
                            (fn [{:keys [contact]}]
                              (some-> contact :public-notice-contact/informed format-date))
                            {:flex 4}]
                           [:public-notice-contact/on-decision
                            (fn [{:keys [contact edit?]}]
                              (if edit?
                                [:div.flex-1.text-right
                                 (cc/button {:kind             :ghost
                                             :size             :small
                                             :icon             i/remove
                                             :icon-description (tr [:cancel])
                                             :on-click         #(>evt [::set-edited-contact nil])}
                                            (tr [:cancel]))
                                 (cc/button {:kind             :primary
                                             :size             :small
                                             :icon             i/check
                                             :icon-description (tr [:public-notice-contact/update])
                                             :on-click         #(>evt [::save-contact fsm-target])
                                             :disabled         (not valid?)}
                                            (tr [:public-notice-contact/update]))]
                                (when-let [decision (p/find-first council-decisions {:db/id (-> contact :public-notice-contact/decision :db/id)})]
                                  (let [date (format-date
                                               (:council-decision/decision-date decision))
                                        desc (if (nil? (:council-decision/attachment-description decision))
                                               (tr [:public-notice-contact/no-description])
                                               (:council-decision/attachment-description decision))]
                                    (str desc ", " date)))))
                            {:flex 8}]]
       :id-func           (comp :db/id :contact)
       :make-actions      (fn [{:keys [contact edit?]}]
                            (when (and (not edit?)
                                       (<sub [:app.front.process/signal-permitted? fsm-target [:process.signal/edit-public-notice-contact {:contact-id (:db/id contact)}]]))
                              [{:title            (tr [:edit])
                                :on-click         #(>evt [::set-edited-contact
                                                          (select-keys contact
                                                                       [:db/id
                                                                        :public-notice-contact/email
                                                                        :public-notice-contact/first-name
                                                                        :public-notice-contact/last-name])])
                                :icon             i/pen
                                :icon-description (tr [:edit])}
                               (when (<sub [:app.front.process/signal-permitted? fsm-target [:process.signal/delete-public-notice-contact {:contact-id (:db/id contact)}]])
                                 {:title            (tr [:remove])
                                  :on-click         #(>evt [::show-remove-modal contact])
                                  :icon             i/trash
                                  :icon-description (tr [:edit])})]))}]]))


(defn- render-contacts [fsm-target tr]
  (let [adding?                (<sub [::adding?])
        contacts               (<sub [::sorted-contacts])
        selected-contacts      (<sub [::selected-contacts])
        council-decisions      (<sub [::council-decisions (:db/id fsm-target)])
        decision-candidate     (<sub [::selected-decision])
        selected-decision      (when (some #(= (:db/id %) decision-candidate) council-decisions) decision-candidate)
        all-contacts-selected? (<sub [::all-contacts-selected?])
        some-contacts?         (not (empty? contacts))
        delete-disabled?       (empty? selected-contacts)
        inform-disabled?       (or (empty? selected-contacts)
                                   (nil? council-decisions)
                                   (nil? selected-decision))
        can-add?               (<sub [:app.front.process/signal-permitted? fsm-target [:process.signal/add-public-notice-contact]])
        can-delete?            (<sub [:app.front.process/signal-permitted? fsm-target [:process.signal/delete-public-notice-contact]])]
    [:div
     [add-contact-block (util/mmap fsm-target tr adding?)]
     (when-not adding?
       [:div.flex.flex-row.flex-wrap.mb-1
        [:div.flex.flex-col.mr-2
         (when can-add?
           (cc/button {:size             :small
                       :icon             i/plus
                       :icon-description ""
                       :class-name       "my-1"
                       :on-click         #(>evt [::toggle-adding-contact])}
                      (tr [:public-notice-contact/add])))
         (when some-contacts?
           (if all-contacts-selected?
             (cc/button {:size       :small
                         :icon       i/remove
                         :class-name "my-1"
                         :on-click   #(>evt [::unselect-all-contacts])}
                        (tr [:public-notice-contact/select-none]))
             (cc/button {:size       :small
                         :icon       i/check
                         :class-name "my-1"
                         :on-click   #(>evt [::select-all-contacts contacts])}
                        (tr [:public-notice-contact/select-all]))))]
        [:div.flex.flex-col.mr-2
         (when (and some-contacts? can-delete?)
           [ui/modal-confirmation-button
            {:tr                  tr
             :id                  "delete-selected-contacts"
             :modal-title         (tr [:public-notice-contact/remove-contacts?])
             :disabled?           delete-disabled?
             :trigger-button-opts {:disabled   delete-disabled?
                                   :size       :small
                                   :icon       i/trash
                                   :class-name "my-1"}
             :modal-class         "text-left"
             :trigger-button-text (tr [:public-notice-contact/remove-contacts])
             :on-yes-click        #(do
                                     (for-all [contact contacts]
                                       (when (p/find-first selected-contacts (:db/id contact))
                                         (if (nil? (:public-notice-contact/informed contact))
                                           (>evt [::delete-contact tr (:db/id contact)
                                                  (:public-notice-contact/email contact)
                                                  fsm-target])
                                           (>evt [:notifications/add
                                                  :toast
                                                  :warning
                                                  (tr [:public-notice-contact/unable-to-remove-title])
                                                  (tr [:public-notice-contact/unable-to-remove]
                                                      [(:public-notice-contact/email contact)])]))))
                                     (>evt [::unselect-all-contacts]))}])
         (when some-contacts?
           [ui/modal-confirmation-button
            {:tr                  tr
             :id                  "inform-selected-contacts"
             :modal-title         (tr [:public-notice-contact/inform-selected?])
             :disabled?           inform-disabled?
             :trigger-button-opts {:disabled   inform-disabled?
                                   :size       :small
                                   :icon       Send32
                                   :class-name "my-1"}
             :modal-class         "text-left"
             :trigger-button-text (tr [:public-notice-contact/inform-selected])
             :on-yes-click        #(for-all [id selected-contacts]
                                     (for-all [contact contacts]
                                       (when (= (:db/id contact) id)
                                         (>evt [::inform-contact id
                                                (:public-notice-contact/email
                                                  contact) tr]))))}])]
        [:div.flex.flex-col.mr-2
         (when some-contacts?
           (cc/select {:id              "select-decision"
                       :label-text      ""
                       :no-label        true
                       :aria-labelledby "select-decision-placeholder"
                       :disabled        (empty? council-decisions)
                       :value           (if (nil? selected-decision)
                                          "placeholder"
                                          selected-decision)
                       :on-change       #(>evt [::select-decision (long (futil/tval %))])}
                      (cc/select-item {:id       "select-decision-placeholder"
                                       :text     (tr [:public-notice-contact/choose-decision])
                                       :value    "placeholder"
                                       :disabled true})
                      (futil/for-frag [decision council-decisions]
                        (let [date ((<sub [::date-util/date-fn])
                                    (:council-decision/decision-date decision))
                              desc (if (nil? (:council-decision/attachment-description decision))
                                     (tr [:public-notice-contact/no-description])
                                     (:council-decision/attachment-description decision))]
                          (cc/select-item {:text  (str desc ", " date)
                                           :value (:db/id decision)})))))]])
     [contact-table tr]]))


(defn section [fsm-target]
  (let [tr (<sub [:tr])]
    [:div.items-center.mb-4.bg-ui-light-gray.p-4
     [:div.flex.justify-between.flex-nowrap.items-center.mb-4
      [:h4.uppercase (tr [:public-notice-contact/contacts])]
      [export-button tr]]
     [:p (tr [:public-notice-contact/contacts-legend])]
     [render-contacts fsm-target tr]]))
